import React from "react";
import { Link } from "react-router-dom";

import Icon from "components/Icon";
import { useAnswerContext } from "contexts/answerContext";
import { getName } from "reducers/projects";

import styles from "./SubHeader.scss";

const SubHeader = ({ requirement }) => {
  const { record } = useAnswerContext();
  const businessName = getName(record);

  const projectLink = `/projects/${record.id}/apply`;
  return (
    <div className={styles.container}>
      <div className={styles.gutters}>
        <div className={styles.subHeaderContainer}>
          <div className={styles.businessName}>
            <Link to={projectLink}>{businessName}</Link>
          </div>
          <Icon icon="caret-right" />
          <div className={styles.requirementName}>{requirement?.name}</div>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
